export const offer_uses_cerebro_handoff = (offer = {}) => {
    return offer?.workflow?.handoff === 'cerebro';
};

export const offer_has_pending_cerebro_phase = (offer = {}) => {
    return offer_uses_cerebro_handoff(offer)
        && ['preparer', 'creator'].includes(offer.workflow?.turn);
};

export const offer_cerebro_task_url = (offer = {}, baseUrl = '', language = 'el') => {
    if (!offer_has_pending_cerebro_phase(offer)) {
        return '';
    }

    const phaseResult = (offer.workflow.cerebroSync?.preoffer?.results || []).find((result) => {
        return (result.stage || result.issue?.preofferStage) === offer.workflow.turn
            && result.issue?._id
            && result.board;
    });

    if (!phaseResult || !baseUrl) {
        return '';
    }

    return `${baseUrl.replace(/\/$/, '')}/${language}/${encodeURIComponent(phaseResult.board)}/board?issueId=${encodeURIComponent(phaseResult.issue._id)}`;
};
